import { Component, h, Prop } from '@stencil/core';
import store from '../../../helpers/store';

import logoOntrace from '../../../assets/logo-ontrace.svg';
import icoErr from '../../../assets/landing/ico-phone-err.svg';

@Component({
  tag: 'error-end',
  styleUrl: 'error-end.css',
  shadow: false,
})
export class ErrorEnd {
  @Prop() message: string;
  @Prop() errorTitle: string;

  async componentDidLoad() {}

  render() {
    return (
      <div class="container flex center">
        <div class="px-3">
          <div class="mb-1 ml-1 text-center">
            <img src={icoErr} style={{ width: '60px' }}></img>
          </div>
          <h1 class="text-center mb-2">{this.errorTitle}</h1>

          <div class="text-center mb-4">
            <p>{store.requestId}</p>
          </div>
          <div>
            <p class="color-red text-center">{this.message}</p>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
